export const CONSENT_COOKIE_NAME = 'c15t-consent';
